<template>
  <div class="home_container">
    <!-- 顶部悬浮时的占位 -->
    <div class="top_placeholder" v-if="isTopReached"></div>

    <div class="head_container" :class="{ 'top-reached': isTopReached }">
      <!-- 订单处理提示 -->
      <div
        class="order_tip flex-between"
        v-if="isOrder && !isTopReached && isOrderTip"
      >
        <div class="left flex-rowl">
          <div class="icon flex-rowl">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/message_icon.png')"
            ></el-image>
          </div>
          <p>
            有未完成支付的订单等待处理。<span
              @click="handleGo('cRetailOrderList')"
              >[ 点击查看详情... ]</span
            >
          </p>
        </div>
        <div class="close felx-rowr" @click="isOrderTip = false">
          [ 关闭 ] <span class="iconfont icon-dangeyichuicon"></span>
        </div>
      </div>
      <!-- 搜索、搜索栏目 -->
      <div class="search_container flex-between">
        <div class="sraech_sort flex-rowl">
          <div class="rest_box flex-rowl" @click="handleRest">
            Reset <span class="rest_icon"></span>
          </div>
          <div class="ordertype_box flex-rowl">
            Sales Popularity
            <span class="shangzhang_icon" @click="handleOrderType(2)"></span>
            <span class="xiajiang_icon" @click="handleOrderType(3)"></span>
          </div>
        </div>
        <div class="search flex-rowl">
          <div class="txt" @click="handleHotSearchMore">Search</div>
          <div class="search_input_box flex-rowl">
            <el-input
              v-model="params.keyword"
              placeholder="Enter Keywords"
              class="search_input"
              @keyup.enter.native="handleSearch({ keyword: params.keyword })"
            ></el-input>
            <span @click="handleSearch({ keyword: params.keyword })"></span>
          </div>

          <!-- 使用 <transition> 组件添加过渡动画 -->
          <transition name="slide">
            <div
              class="hot_search_list_expanded"
              v-if="showAllHotSearch"
              @mouseleave="handleMouseLeave"
            >
              <div class="expanded_content flex-rowl">
                <p v-for="(item, index) in hotSearchList" :key="index" @click="handleSearchAndHideHotSearch({ keyword: item.topic })">
                  {{ item.topic }}
                </p>
              </div>
              <div class="expanded_more flex-rowr">
                <span></span>
                <p @click="handleToast">Check Search Report / past month →</p>
              </div>
            </div>
          </transition>
        </div>
      </div>

      <!-- 栏目 start -->
      <div
        class="shop_category_wrap"
        v-if="!isTopReached"
        @mouseleave="handleShopCategoryWrapLeave"
      >
        <swiper :options="swiperOption1" ref="mySwiper">
          <swiper-slide v-for="(item, index) in commodityList" :key="index">
            <div
              class="shop_category_main flex-rowl"
              @mouseenter="handleShopCategoryMainEnter(index)"
            >
              <!--  -->
              <div class="thumb">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="'https://shop.winksshowp.com/Upload/' + item.img"
                  fit="cover"
                ></el-image>
              </div>
              <div class="content">
                <h1>{{ item.mul_labelname }}</h1>
                <p>{{ item.mul_labelcont }}</p>
              </div>
            </div>
            <!-- 其他更多内容 -->
            <transition name="slide-down">
              <div
                class="shop_category_other"
                v-show="item.showMore"
                @mouseleave="item.showMore = false"
              >
                <!-- 商品二、三级分类 -->
                <div class="category-level2-level3 flex-rowl">
                  <div class="icon_box flex-rowc"><span></span></div>
                  <div class="category-level2">
                    <div
                      v-for="(child2, index2) in item.childs2"
                      :key="index2"
                      @mouseenter="handleMouseEnter($event, child2)"
                      @mouseleave="child2.showMore = false"
                      class="category-level2-item flex-rowl"
                    >
                      <div
                        class="txt flex-rowc"
                        @click="
                          handleSearch({
                            labelid: item.id,
                            labelid2: child2.id,
                          })
                        "
                      >
                        {{ child2.mul_labelname }}
                      </div>
                      <div
                        class="category-level3"
                        v-if="child2.showMore && child2.childs3.length > 0"
                        :style="{ left: child2.leftOffset + 'px' }"
                      >
                        <div
                          v-for="(child3, index3) in child2.childs3"
                          :key="index3"
                          class="category-level3-item"
                          @click="
                            handleSearch({
                              labelid: item.id,
                              labelid2: child2.id,
                              labelid3: child3.id,
                            })
                          "
                        >
                          {{ child3.mul_labelname }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 商品一级分类对应的关键字标签 -->
                <div
                  class="keyword-labels flex-rowl"
                  v-if="
                    item.cmkeysids_onelist && item.cmkeysids_onelist.length > 0
                  "
                >
                  <div class="icon"></div>
                  <div class="content">
                    <div class="content_wrap flex-rowl">
                      <p
                        v-for="(
                          keyword, keywordIndex
                        ) in item.cmkeysids_onelist"
                        :key="keywordIndex"
                        @click="
                          handleSearch({
                            labelid: item.id,
                            labels: keyword.labelname,
                          })
                        "
                      >
                        # {{ keyword.labelname }}
                      </p>
                    </div>
                    <div class="more flex-rowc">More #</div>
                  </div>
                </div>
              </div>
            </transition>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev commodity_wrap_swiper-prev">
          <i class="iconfont icon-right"></i>
        </div>
        <div class="swiper-button-next commodity_wrap_swiper-next">
          <i class="iconfont icon-right"></i>
        </div>
      </div>
      <!-- 栏目 end -->

      <!-- 商品标签 start -->
      <div class="label_container flex-rowl">
        <div class="icon"></div>
        <div class="label_wrap flex-rowl">
          <div class="label_list flex-rowl">
            <div
              class="label_item"
              v-for="(item, index) in getDisplayLabels"
              :key="index"
              @click="handleSearch({ labels: item.labelname || item.typename })"
            >
              # {{ item.labelname || item.mul_typename }}
            </div>
            <div
              class="more flex-rowc"
              @click="showMoreLabels = !showMoreLabels"
            >
              More #
            </div>
            <transition name="slide">
              <div
                v-if="showMoreLabels"
                class="more-label-list flex-rowl"
                @mouseleave="showMoreLabels = false"
              >
                <div
                  class="label_item"
                  v-for="(item, index) in getMoreLabels"
                  :key="index"
                  @click="
                    handleSearchAndHideLabels({
                      labels: item.labelname || item.typename,
                    })
                  "
                >
                  # {{ item.labelname || item.mul_typename }}
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
      <!-- 商品标签 end -->
    </div>

    <!-- 商品列表 start -->
    <div class="commodity_container">
      <template v-if="isDataLoaded && dataList.length > 0">
        <div
          class="commodity_wrap"
          v-for="(item, index) in dataList"
          :key="index"
        >
          <div class="commodity_list flex-rowl">
            <div
              class="commodity_list_item"
              v-for="(itemChild, indexChild) in item"
              :key="indexChild"
            >
              <div class="thumb">
                <el-image
                  style="width: 100%; height: 100%"
                  :src="itemChild.banner"
                  fit="cover"
                ></el-image>
                <div class="label_group flex-colc">
                  <p
                    v-for="(itemLabel, indexLabel) in itemChild.labelslist"
                    :key="indexLabel"
                  >
                    # {{ itemLabel.mul_labelcont }}
                  </p>
                </div>
              </div>
              <div class="content">
                <div class="tit">{{ itemChild.mul_commodityname }}</div>
                <div class="brand flex-rowl">
                  <span class="iconfont icon-peihuo"></span>
                  {{
                    itemChild.qyename
                      ? itemChild.qyename
                      : itemChild.qy_accountid
                  }}
                </div>
                <div class="txt">400+ bought Past 30 days</div>
                <div class="grade flex-rowl">
                  <p>Buyers' Evaluate：</p>
                  <div class="leval_group flex-rowl">
                    <span
                      v-for="(itemScore, indexScore) in 5"
                      :key="indexScore"
                      class="iconfont icon-pingfen1"
                      :class="{
                        active: indexScore < item.countryScore,
                        ['score_' + itemScore]: true,
                      }"
                    ></span>

                    <!-- <span class="iconfont icon-pingfen1 active"></span>
                    <span class="iconfont icon-pingfen1 active"></span>
                    <span class="iconfont icon-pingfen1"></span>
                    <span class="iconfont icon-pingfen1"></span> -->
                  </div>
                </div>
                <div class="price flex-rowl">
                  <div class="symbol flex-colc">
                    <span>Reference</span>
                    <span class="unit">({{ COUNTRY.moneyslog }}） : </span>
                  </div>
                  <div
                    class="num_txt"
                    @click="handleNewPrice(itemChild)"
                    v-if="!itemChild.mulstr_price"
                  >
                    显示最新价格信息
                  </div>
                  <div class="num" v-html="itemChild.mulstr_price" v-else></div>
                </div>
                <!-- 价格组合 -->
                <div class="price_group flex-rowl">
                  <div
                    class="label flex-rowl"
                    @click="togglePriceDetail(index, indexChild)"
                  >
                    <p>Retail</p>
                    <p>Batch</p>
                    <p>Big Orders</p>
                  </div>
                  <!-- 价格详情 -->
                  <transition name="slide">
                    <div
                      class="price_detail"
                      v-if="itemChild.isPriceDetailVisible"
                    >
                      <div class="head flex-between">
                        <p>Reference Price</p>
                        <div
                          class="close flex-rowl"
                          @click="togglePriceDetail(index, indexChild)"
                        >
                          <span class="iconfont icon-dangeyichuicon"></span>
                        </div>
                      </div>
                      <div class="price_item">
                        <div class="txt1 flex-between">
                          <p>Retail</p>
                          <div class="num">1 Piece</div>
                        </div>
                        <div class="txt2 flex-rowl">
                          <div class="symbol flex-rowl">
                            ({{ COUNTRY.moneyslog }})：
                          </div>
                          <div class="num flex-rowl">
                            <span>{{ itemChild.mul_price }}</span
                            >/Per
                          </div>
                        </div>
                      </div>
                      <div class="price_item">
                        <div class="txt1 flex-between">
                          <p>Batch</p>
                          <div class="num">
                            ≥ <span>{{ itemChild.startnum2 }}</span> Piece
                          </div>
                        </div>
                        <div class="txt2 flex-rowl">
                          <div class="symbol flex-rowl">
                            ({{ COUNTRY.moneyslog }})：
                          </div>
                          <div class="num flex-rowl">
                            <span>{{ itemChild.mul_groupprice }}</span
                            >/Per
                          </div>
                        </div>
                      </div>
                      <div class="price_item">
                        <div class="txt1 flex-between">
                          <p>Big Orders</p>
                          <div class="num">
                            ≥ <span>{{ itemChild.startnum3 }}</span> Piece
                          </div>
                        </div>
                        <div class="txt2 flex-rowl">
                          <div class="symbol flex-rowl">
                            ({{ COUNTRY.moneyslog }})：
                          </div>
                          <div class="num flex-rowl">
                            <span>{{ itemChild.mul_pfprice }}</span
                            >/Per
                          </div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>
                <div
                  class="add_order_btn"
                  @click="handleAddOrder(itemChild)"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="commodity_pagin flex-rowc">
          <el-pagination
            :page-size="30"
            layout="prev, pager, next"
            :total="listTotal"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </template>

      <!-- 暂无找到商品 -->
      <div class="no_commodity" v-if="isDataLoaded && dataList.length === 0">
        <div class="no_commodity_content">
          <el-empty description="暂无商品"></el-empty>
        </div>
      </div>
    </div>
    <!-- 商品列表 end -->

    <!-- 左侧固定内容 start -->
    <div class="left-fixed" :class="{ 'slide-in': isTopReached }">
      <!-- 商品分类 -->
      <div
        class="shop-category-wrap"
        :class="{ 'new-shop-category-style': shouldAddShopCategoryClass }"
      >
        <div class="shop-category-content">
          <!-- 展开 -->
          <div
            class="shop-category-content-show flex-colc"
            v-if="shopCategoryExpanded"
            ref="swiperContainer"
            :style="{ display: swiperVisible ? 'block' : 'none' }"
          >
            <div
              class="shop_category_wrap"
              @mouseleave="handleShopCategoryWrapLeave"
            >
              <swiper :options="swiperOption1" ref="mySwiperFixed">
                <swiper-slide
                  v-for="(item, index) in commodityList"
                  :key="index"
                >
                  <div
                    class="shop_category_main flex-rowl"
                    @mouseenter="handleShopCategoryMainEnter(index)"
                  >
                    <div class="thumb">
                      <el-image
                        style="width: 100%; height: 100%"
                        :src="'https://shop.winksshowp.com/Upload/' + item.img"
                        fit="cover"
                      ></el-image>
                    </div>
                    <div class="content">
                      <h1>{{ item.mul_labelname }}</h1>
                      <p>{{ item.mul_labelcont }}</p>
                    </div>
                  </div>
                  <!-- 其他更多内容 -->
                  <transition name="slide-down">
                    <div
                      class="shop_category_other"
                      v-show="item.showMore"
                      @mouseleave="item.showMore = false"
                    >
                      <!-- 商品二、三级分类 -->
                      <div class="category-level2-level3 flex-rowl">
                        <div class="icon_box flex-rowc"><span></span></div>
                        <div class="category-level2">
                          <div
                            v-for="(child2, index2) in item.childs2"
                            :key="index2"
                            @mouseenter="handleMouseEnter($event, child2)"
                            @mouseleave="child2.showMore = false"
                            class="category-level2-item flex-rowl"
                          >
                            <div
                              class="txt flex-rowc"
                              @click="
                                handleSearchAndHideFixdCategory({
                                  labelid: item.id,
                                  labelid2: child2.id,
                                })
                              "
                            >
                              {{ child2.mul_labelname }}
                            </div>
                            <div
                              class="category-level3"
                              v-if="
                                child2.showMore && child2.childs3.length > 0
                              "
                              :style="{ left: child2.leftOffset + 'px' }"
                            >
                              <div
                                v-for="(child3, index3) in child2.childs3"
                                :key="index3"
                                class="category-level3-item"
                                @click="
                                  handleSearchAndHideFixdCategory({
                                    labelid: item.id,
                                    labelid2: child2.id,
                                    labelid3: child3.id,
                                  })
                                "
                              >
                                {{ child3.mul_labelname }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- 商品一级分类对应的关键字标签 -->
                      <div
                        class="keyword-labels flex-rowl"
                        v-if="
                          item.cmkeysids_onelist &&
                          item.cmkeysids_onelist.length > 0
                        "
                      >
                        <div class="icon"></div>
                        <div class="content">
                          <div class="content_wrap flex-rowl">
                            <p
                              v-for="(
                                keyword, keywordIndex
                              ) in item.cmkeysids_onelist"
                              :key="keywordIndex"
                              @click="
                                handleSearchAndHideFixdCategory({
                                  labelid: item.id,
                                  labels: keyword.labelname,
                                })
                              "
                            >
                              # {{ keyword.labelname }}
                            </p>
                          </div>
                          <div class="more flex-rowc">More #</div>
                        </div>
                      </div>
                    </div>
                  </transition>
                </swiper-slide>
              </swiper>
              <div class="swiper-button-prev commodity_wrap_swiper-prev">
                <i class="iconfont icon-right"></i>
              </div>
              <div class="swiper-button-next commodity_wrap_swiper-next">
                <i class="iconfont icon-right"></i>
              </div>
            </div>
          </div>
          <!-- 收缩 -->
          <div class="shop-category-content-hide flex-rowc" v-else>
            <div class="icon"></div>
          </div>
        </div>

        <!-- 切换按钮 -->
        <div
          class="toggle-btn flex-rowc"
          :class="{ 'new-toggle-btn': shouldAddShopCategoryClass }"
          @click="toggleShopCategory"
        >
          <span></span>
        </div>
      </div>

      <!-- 订单处理提示 -->
      <div
        v-if="isOrder"
        class="order-tip-wrap"
        :class="{ 'new-order-tip-style': shouldAddOrderTipClass }"
      >
        <div class="order-tip-content">
          <!-- 展开 -->
          <div class="order-tip-content-show flex-colc" v-if="orderTipExpanded">
            <div class="txt">
              有未完成支付的订单 <br />
              等待处理。
            </div>
            <div class="more" @click="handleGo('cRetailOrderList')">
              [ 点击查看详情... ]
            </div>
          </div>
          <!-- 收缩 -->
          <div class="order-tip-content-hide flex-rowc" v-else>
            <div class="icon"></div>
            <span class="mark"></span>
          </div>
        </div>
        <!-- 切换按钮 -->
        <div
          class="toggle-btn flex-rowc"
          :class="{ 'new-toggle-btn': shouldAddOrderTipClass }"
          @click="toggleOrderTip"
        >
          <span></span>
        </div>
      </div>
    </div>
    <!-- 左侧固定内容 end -->

    <!-- 用户完善信息提示 -->
    <el-dialog
      :visible.sync="showUserInfoDialog"
      :show-close="false"
      custom-class="custom-dialog"
    >
      <template #title>
        <div class="custom-header flex-rowl">
          <div class="tit">
            为了更好的使用 Wink SShoWP 的服务，你需要完善以下信息：
          </div>
          <div class="close flex-rowc" @click="handleDialog"></div>
        </div>
      </template>
      <div class="content flex-between">
        <div
          class="item flex-colc"
          :class="{ disable: isWarehouse }"
          v-if="!isWarehouse"
        >
          <div class="img flex-rowc">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/set_warehouse_icon.png')"
            ></el-image>
          </div>
          <div class="btn flex-rowc" @click="handleGo('warehouseInfo')">
            完善仓库信息
          </div>
        </div>
        <div
          class="item flex-colc"
          :class="{ disable: isLogistics }"
          v-if="!isLogistics"
        >
          <div class="img flex-rowc">
            <el-image
              style="width: 100%; height: 100%"
              :src="require('@/assets/images/set_receiving_icon.png')"
            ></el-image>
          </div>
          <div class="btn flex-rowc" @click="handleGo('receivingInfo')">
            完善收货信息
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
  <script>
// 引入文件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import {
  encryptstringadd,
  encryptstringview,
  getCommonditySpecial,
  getCommondityLabel,
  getShopKeywordLabel,
  getHotSearchList,
} from "../api/api";
import {
  editShopMultiPrice,
  addShopMultiPrice,
  getOrderListWeb,
} from "../api/shop";
import {
  getSpecialUserResourceList,
  getLogisticsAddressList,
} from "../api/managCenter";
import { calculator } from "../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "product-aggregation-page",
  //import引入的组件需要注入到对象中才能使用
  components: { swiper, swiperSlide },
  data() {
    return {
      dataList: [],
      listTotal: 0,
      params: {
        Page: "1",
        PageSize: 30,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: "",
        countryid: "", // 根据国家屏蔽特定的企业 countryid从接口549获取
        fav_openid: "",
        labelid: "",
        labelid2: "",
        labelid3: "",
      },

      // 多币种价格
      multilingualPrice: "",

      // 是否触发订单按钮
      triggerOrder: {
        isClick: false,
        qyid: "",
        id: "",
      },

      // 是否有未完成的订单
      isOrder: false,
      // 是否触发按钮隐藏订单未完成提示
      isOrderTip: true,

      // 是否显示用户完善信息提示
      showUserInfoDialog: false,
      // 存在物流信息
      isLogistics: false,
      // 存在仓库信息
      isWarehouse: false,

      swiperOption1: {
        slidesPerView: 5,
        autoplay: {
          //自动开始
          delay: 2000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        loop: false,
        initialSlide: 0, //初始化页码
        prevButton: ".commodity_wrap_swiper-prev",
        nextButton: ".commodity_wrap_swiper-next",
      },
      // 商品标签
      labelList: [],
      // 商品一级分类对应的标签
      labelList2: [],
      showMoreLabels: false, // 控制是否显示更多标签

      // 商品分类
      commodityList: [],
      isTopReached: false, // 是否固定元素

      orderTipExpanded: false, // 订单提示展开状态
      shopCategoryExpanded: false, // 商品分类展开状态
      shouldAddOrderTipClass: false, // 控制订单提示是否添加新类的标志
      shouldAddShopCategoryClass: false, // 控制商品分类是否添加新类的标志
      swiperVisible: false, // swiper 是否可见

      isDataLoaded: false, // 新增变量，标记数据是否加载完成

      hotSearchList: [], // 热门搜索
      showAllHotSearch: false, // 控制是否显示全部热门搜索内容
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "dataPage", "COUNTRY", "USERINFO", "COUNTRYLIST"]),
    // ... 其他计算属性 ...
    getDisplayLabels() {
      if (this.labelList2.length > 0) {
        return this.labelList2.slice(0, 8);
      } else {
        return this.labelList.filter((item) => item.isintro == 1).slice(0, 8);
      }
    },
    getMoreLabels() {
      if (this.labelList2.length > 0) {
        return this.labelList2;
      } else {
        return this.labelList;
      }
    },
  },

  created() {
    let { COUNTRY } = this.$store.state;
    this.params.countryid = COUNTRY.countryid ? parseInt(COUNTRY.countryid) : 1;

    this.params.Page = this.dataPage;
    this.params.fav_openid = this.OPENID;

    // 初始化获取总的数据
    this.initData();

    // 监听滚动事件
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleMultilingualName(type, dataList, key1, key2) {
      let { countryid } = this.COUNTRY;
      dataList.forEach((v) => {
        // 根据不同国家countryid获取评分
        if (v.ams_shop_commodity_area && v.ams_shop_commodity_area.length > 0) {
          v.ams_shop_commodity_area.forEach((v1) => {
            if (v1.countryid == countryid) {
              v.countryScore = v1.average;
            }
          });
        }

        if (countryid == 1) {
          v[`mul_${key1}`] = v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.price;
            v.mul_groupprice = v.groupprice;
            v.mul_pfprice = v.pfprice;
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }
          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 8) {
          // 英文
          v[`mul_${key1}`] = v[key1 + "_e"] ? v[key1 + "_e"] : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_e"] ? v[key2 + "_e"] : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.ame_price
              ? v.ams_shop_commodity_exrate.ame_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.ame_tuan
              ? v.ams_shop_commodity_exrate.ame_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.ame_tuan_base
              ? v.ams_shop_commodity_exrate.ame_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 2) {
          // 俄语
          v[`mul_${key1}`] = v[key1 + "_m"]
            ? v[key1 + "_m"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_m"]
              ? v[key2 + "_m"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_m
                  ? label.labelcont_m
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.lu_price
              ? v.ams_shop_commodity_exrate.lu_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.lu_tuan
              ? v.ams_shop_commodity_exrate.lu_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.lu_tuan_base
              ? v.ams_shop_commodity_exrate.lu_tuan_base
              : "";

            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_m
                  ? child2.labelname_m
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_m
                      ? child3.labelname_m
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        } else if (countryid == 4) {
          // 越语
          v[`mul_${key1}`] = v[key1 + "_y"]
            ? v[key1 + "_y"]
            : v[key1 + "_e"]
            ? v[key1 + "_e"]
            : v[key1];
          if (key2) {
            v[`mul_${key2}`] = v[key2 + "_y"]
              ? v[key2 + "_y"]
              : v[key2 + "_e"]
              ? v[key2 + "_e"]
              : v[key2];
          }

          // 处理商品数据
          if (type == "shop") {
            // 处理 labelslist 数组
            if (v.labelslist && Array.isArray(v.labelslist)) {
              v.labelslist = v.labelslist.map((label) => {
                label.mul_labelcont = label.labelcont_y
                  ? label.labelcont_y
                  : label.labelcont_e
                  ? label.labelcont_e
                  : label.labelcont;
                return label;
              });
            }
            // 价格
            v.mul_price = v.ams_shop_commodity_exrate.yue_price
              ? v.ams_shop_commodity_exrate.yue_price
              : "";
            v.mul_groupprice = v.ams_shop_commodity_exrate.yue_tuan
              ? v.ams_shop_commodity_exrate.yue_tuan
              : "";
            v.mul_pfprice = v.ams_shop_commodity_exrate.yue_tuan_base
              ? v.ams_shop_commodity_exrate.yue_tuan_base
              : "";
            // 处理价格格式
            v.mulstr_price = formatPrice(v.mul_price);
          }

          // 处理商品分类
          if (type == "shopLabel") {
            if (v.childs2 && Array.isArray(v.childs2)) {
              v.childs2.forEach((child2) => {
                child2.mul_labelname = child2.labelname_y
                  ? child2.labelname_y
                  : child2.labelname_e
                  ? child2.labelname_e
                  : child2.labelname;
                if (child2.childs3 && Array.isArray(child2.childs3)) {
                  child2.childs3.forEach((child3) => {
                    child3.mul_labelname = child3.labelname_y
                      ? child3.labelname_y
                      : child3.labelname_e
                      ? child3.labelname_e
                      : child3.labelname;
                  });
                }
              });
            }
          }
        }
      });
      return dataList;

      // 定义处理价格格式的函数
      function formatPrice(price) {
        const priceStr = String(price);
        const parts = priceStr.split(".");
        if (parts.length > 1) {
          return `${parts[0]}.<span>${parts[1]}</span>`;
        }
        return priceStr;
      }
    },

    // 通过解密获取参数
    async encryptstringview(encryptstring, openid, loading) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { keyword, labels, labelid, labelid2, labelid3 } = JSON.parse(
          res.jsondata
        );
        this.params.keyword = keyword;
        this.params.labels = labels;
        this.params.labelid = labelid;
        this.params.labelid2 = labelid2;
        this.params.labelid3 = labelid3;

        this.getCommondity(loading);
      } else {
        this.$router.back();
      }
    },

    // 初始化获取总的数据
    async initData() {
      let { routerList, OPENID } = this.$store.state;
      let { name } = this.$route;
      const loading = this.$loading({
        lock: true,
        text: "加载中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      try {
        const res1 = await getShopKeywordLabel(); // 获取商品关键字标签
        // 对res1进行过滤labelstate=1，在进行sort排序
        let recomData = res1
          .filter((v) => v.labelstate == 1)
          .sort((a, b) => b.sort - a.sort);
        // 进行不同国家语言处理
        let MultilingualArr1 = this.handleMultilingualName(
          "other",
          recomData,
          "typename"
        );
        this.labelList = MultilingualArr1;

        const res2 = await getHotSearchList(); // 获取热门搜索
        // 对res1.list进行过滤（isuse=1）；利用sortno进行从小到大的排序
        if (res2 && res2.list) {
          const filteredAndSortedList = res2.list
            .filter((v) => v.isuse == 1)
            .sort((a, b) => a.sortno - b.sortno);
          this.hotSearchList = filteredAndSortedList;
        }

        // 商品分类
        const res = await getCommondityLabel(); // 获取商品分类
        // 筛选五个分类：id=21545efbac6545f89ac8ccf39f25b2ed（鞋袜）、216aeab8f3d14325b1b80f6cfe31b46e（美妆&护肤）、e15491058139436d87c2e71ff04a30a1（电子&数码产品）、e97d25cf40f94f059f017d82310bbd60（珠宝配饰）、f23677a3e21742ba8ef11c3b1ea761ab（服饰穿搭）
        let filterArr = res.filter(
          (v) =>
            v.id == "21545efbac6545f89ac8ccf39f25b2ed" ||
            v.id == "216aeab8f3d14325b1b80f6cfe31b46e" ||
            v.id == "e15491058139436d87c2e71ff04a30a1" ||
            v.id == "e97d25cf40f94f059f017d82310bbd60" ||
            v.id == "f23677a3e21742ba8ef11c3b1ea761ab"
        );

        // 不同国家选择多语言
        let MultilingualArr = this.handleMultilingualName(
          "shopLabel",
          filterArr,
          "labelname",
          "labelcont"
        );

        // 补充是否显示其他更多内容字段
        MultilingualArr.forEach((item) => {
          item.showMore = false;
          if (item.childs2 && Array.isArray(item.childs2)) {
            item.childs2.forEach((child2) => {
              child2.showMore = false;
            });
          }
        });

        this.commodityList = MultilingualArr;

        // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
        if (name in routerList) {
          if (routerList[name].encryptstring == "") return;
          this.encryptstringview(
            routerList[name].encryptstring,
            OPENID,
            loading
          );
        }

        // 分类对应的商品全部加载完整以后loading设置为false
        // this.loading = false;

        // 商品加载完成之后获取接口getOrderListWeb
        await this.getOrderListWeb();

        // 上面的完成之后获取接口getSpecialUserResourceList、getLogisticsAddressList
        await this.getSpecialUserInfo();
      } catch (error) {
        console.error("获取商品分类失败:", error);
      } finally {
        // this.loading = false;
        loading.close();
      }
    },

    // 获取商品列表
    async getCommondity(loading, replace = false) {
      console.log(replace, "===-===");

      let { params } = this;
      try {
        const res = await getCommonditySpecial(params);
        // 假设 res 是一个包含商品列表的数组
        if (res.list && res.list.length > 0) {
          // 不同国家选择多语言
          let MultilingualArr = this.handleMultilingualName(
            "shop",
            res.list,
            "commodityname"
          );
          // 将 MultilingualArr 处理成二维数组，每组包含 5 条数据
          const chunkSize = 5;
          const twoDimensionalArray = [];
          for (let i = 0; i < MultilingualArr.length; i += chunkSize) {
            twoDimensionalArray.push(MultilingualArr.slice(i, i + chunkSize));
          }
          this.dataList = twoDimensionalArray;
          this.listTotal = res.total;
        } else {
          this.dataList = [];
          this.listTotal = 0;
        }

        // 如果labelid不为空，则获取commodityList中对应的一级分类中的cmkeysids_onelist赋值给labelList2
        if (params.labelid) {
          this.commodityList.forEach((item) => {
            if (item.id == params.labelid) {
              this.labelList2 = item.cmkeysids_onelist
                ? item.cmkeysids_onelist
                : [];
            }
          });
        } else {
          this.labelList2 = [];
        }

        // 数据加载完成后设置 isDataLoaded 为 true
        this.isDataLoaded = true;
        loading.close();
      } catch (error) {
        console.error("获取商品列表失败:", error);
        loading.close();
      }
    },

    // 获取订单
    async getOrderListWeb() {
      let params = {
        openid: this.OPENID,
        ordertype: "", // 订单类型
        keyword: "",
        qyid: "",
        returntalk: "", // 退款状态
        ischeck: "", // 订单审核
        paystate: 0, // 支付状态 =0=未支付 1=已支付
        orderstate: "未支付", // 订单状态 =未支付 待发货 已发货 已签收 已申请退费 已退费 已完成
        pageindex: 1,
        pagesize: 15,
        currency_trans: this.COUNTRY.id,
      };
      try {
        const res = await getOrderListWeb(params);
        this.isOrder = res.total > 0 ? true : false;
      } catch (error) {
        console.error("获取订单列表失败:", error);
      }
    },

    // 用户完善信息提示
    async getSpecialUserInfo() {
      // 获取仓库物流信息
      let dataForm = {
        pageindex: 1,
        pagesize: 1,
        keyword: "",
        isuse: "", // 是否启用 =1=启用 0=停用
        openid: this.OPENID,
        whtype: "", // 仓库服务类型 =私有仓 公共服务仓
        managetype: "", // 管理属性 =工厂 第三方服务机构 标准仓库
        countryids: this.COUNTRY.countryid, // 所在国家
        runstate: "", // 业务状态管理 =1=开启入库&代发业务 2=关闭入库&代发业务
        replacetype: "", // 代发业务模式管理 =1=一件代发（to 零售） 2=大货代发（to 集运） 3=退换货处理（to 零售）
        fee_cny: "", // 出入库服务收费币种
      };
      let res1 = await getSpecialUserResourceList(dataForm);
      if (res1.total > 0) {
        this.isWarehouse = true;
      }

      // 获取物流记录
      let logisticsForm = {
        pageindex: 1,
        pagesize: 15,
        keyword: "",
        openid: this.OPENID,
        countryids: this.COUNTRY.countryid,
      };
      let res2 = await getLogisticsAddressList(logisticsForm);
      if (res2.total > 0) {
        this.isLogistics = true;
      }

      if (this.USERINFO.limittype != 3) {
        if (res1.total > 0 && res2.total > 0) {
          this.showUserInfoDialog = false;
        } else {
          this.showUserInfoDialog = true;
        }
      }
    },

    // 最新价格更新
    async handleNewPrice(itemShop) {
      console.log(itemShop, "======");

      // 保存 loading 实例
      const loading = this.$loading({
        lock: true,
        text: "更新价格中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.setShopMultiPrice(itemShop, loading);
    },

    // 创建订单的时候，需要先更新价格
    async handleAddOrder(itemShop) {
      let { COUNTRY } = this;
      // 如果当前国家为中国，不需要更新价格
      if (COUNTRY.countryid == 1) {
        this.handleGoAddOrder(itemShop);
        return;
      }
      // 保存 loading 实例
      const loading = this.$loading({
        lock: true,
        text: "更新价格中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      // 对下面参数进行备注 itemShop：当前的商品 loading：loading实例 isLink：是否需要跳转创建订单页面
      this.setShopMultiPrice(itemShop, loading, true);
    },

    // 跳转创建订单页面
    handleGoAddOrder(item) {
      // 如果isLogistics、isWarehouse 为false，提示用户完善信息
      let { isLogistics, isWarehouse } = this;
      if (!isLogistics || !isWarehouse) {
        this.showUserInfoDialog = true;
        return;
      }
      this.encryptstringadd("cRetailAddOrder", {
        id: item.id,
        qyid: item.qyid,
      });
    },

    // 设置多币种价格
    setShopMultiPrice(itemShop, loading, isLink = false) {
      let { countryExrateObj } = this.USERINFO;
      let newMultilingualPrice = {
        id: itemShop.ams_shop_commodity_exrate.id
          ? itemShop.ams_shop_commodity_exrate.id
          : "",
        cmid: itemShop.id,
      };
      if (countryExrateObj.countryid == 4) {
        // 越南
        newMultilingualPrice.yue_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.yue_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.yue_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.yue_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      } else if (countryExrateObj.countryid == 8) {
        // 美国
        newMultilingualPrice.ame_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.ame_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.ame_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.ame_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      } else if (countryExrateObj.countryid == 3) {
        // 日本
        newMultilingualPrice.jap_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.jap_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.jap_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.jap_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      } else if (countryExrateObj.countryid == 5) {
        // 泰国
        newMultilingualPrice.tai_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.tai_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.tai_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.tai_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      } else if (countryExrateObj.countryid == 2) {
        // 俄罗斯
        newMultilingualPrice.lu_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.lu_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.lu_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.lu_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      } else if (countryExrateObj.countryid == 6) {
        // 加拿大
        newMultilingualPrice.jia_price_base = this.convertCurrency(
          itemShop.cbprice
        );
        newMultilingualPrice.jia_price = this.convertCurrency(itemShop.price);
        newMultilingualPrice.jia_tuan = this.convertCurrency(
          itemShop.groupprice
        );
        newMultilingualPrice.jia_tuan_base = this.convertCurrency(
          itemShop.pfprice
        );
      }

      this.multilingualPrice = newMultilingualPrice;

      if (newMultilingualPrice.id) {
        this.editShopMultiPrice(itemShop, loading, isLink);
      } else {
        this.addShopMultiPrice(itemShop, loading, isLink);
      }
    },

    // 计算汇率转换后的值
    convertCurrency(inputValue) {
      let { countryExrateObj } = this.USERINFO;
      if (
        countryExrateObj.Currency == "韩元" ||
        countryExrateObj.Currency == "越南盾" ||
        countryExrateObj.Currency == "泰铢" ||
        countryExrateObj.Currency == "日元" ||
        countryExrateObj.Currency == "卢布"
      ) {
        return calculator(inputValue)
          .multiply(countryExrateObj.rate)
          .toNumber()
          .toFixed();
      } else {
        let num = calculator(inputValue)
          .multiply(countryExrateObj.rate)
          .toNumber();
        if (Number.isInteger(num)) {
          return num; // 如果是整数，直接返回
        } else {
          return num.toFixed(1); // 如果是小数，保留一位小数
        }
      }
    },

    // 新增多币种价格
    async addShopMultiPrice(itemShop, loading, isLink) {
      try {
        const data = await addShopMultiPrice(this.multilingualPrice);
        if (data.result) {
          // 更新参数并获取商品列表
          await this.getCommondity(loading);

          if (isLink) {
            this.handleGoAddOrder(itemShop);
          }
        } else {
          this.$message.warning(data.message);
        }
      } catch (error) {
        console.error("新增多币种价格失败:", error);
      }
    },
    // 修改多币种价格
    async editShopMultiPrice(itemShop, loading, isLink) {
      try {
        // 调用正确的接口函数
        const data = await editShopMultiPrice(this.multilingualPrice);

        if (data.result) {
          // 更新参数并获取商品列表
          await this.getCommondity(loading);

          if (isLink) {
            this.handleGoAddOrder(itemShop);
          }
        } else {
          this.$message.warning(data.message);
        }
      } catch (error) {
        console.error("修改多币种价格失败:", error);
      }
    },

    // 点击更多热门搜索
    handleHotSearchMore() {
      this.showAllHotSearch = !this.showAllHotSearch;
    },
    // 鼠标移入显示全部热门搜索
    handleMouseLeave() {
      this.showAllHotSearch = false;
    },

    // 关闭弹窗
    handleDialog() {
      this.showUserInfoDialog = false;
    },

    // 原有的方法
    handleScroll() {
      const colmunThree = document.querySelector(".commodity_container");
      if (colmunThree) {
        const rect = colmunThree.getBoundingClientRect();
        this.showMoreLabels = false;
        this.showAllHotSearch = false;
        // 如果元素已固定，且顶部距离大于 30px，取消固定
        if (this.isTopReached && rect.top > 30) {
          this.isTopReached = false;

          this.orderTipExpanded = false;
          this.shopCategoryExpanded = false;
          this.shouldAddOrderTipClass = false;
          this.shouldAddShopCategoryClass = false;

          this.isOrderTip = true;
        }
        // 如果元素未固定，且顶部距离小于等于 0，固定元素
        else if (!this.isTopReached && rect.top <= 60) {
          this.isTopReached = true;
        }
      }
    },

    // 切换订单提示展开状态
    toggleOrderTip() {
      this.orderTipExpanded = !this.orderTipExpanded;
      this.shouldAddOrderTipClass = !this.shouldAddOrderTipClass;
    },
    // 切换商品分类展开状态
    toggleShopCategory() {
      this.shopCategoryExpanded = !this.shopCategoryExpanded;
      this.shouldAddShopCategoryClass = !this.shouldAddShopCategoryClass;
      // 当展开时调用 swiper 的 update 方法
      if (this.shopCategoryExpanded) {
        this.swiperVisible = false; // 隐藏 Swiper 容器
        // 假设这里有异步加载内容的逻辑
        this.loadSwiperContent().then(() => {
          this.$nextTick(() => {
            if (this.$refs.mySwiperFixed && this.$refs.mySwiperFixed.swiper) {
              this.$refs.mySwiperFixed.swiper.update();
              this.swiperVisible = true; // 显示 Swiper 容器
            }
          });
        });
      }
    },

    // 切换商品分类展开状态
    togglePriceDetail(index, indexChild) {
      let { dataList } = this;
      const newDataList = [...dataList];
      const newGoodsList = [...newDataList[index]];
      newGoodsList[indexChild] = {
        ...newGoodsList[indexChild],
        isPriceDetailVisible: !newGoodsList[indexChild].isPriceDetailVisible,
      };
      // 直接将 newGoodsList 赋值给 newDataList[index]
      newDataList[index] = newGoodsList;
      this.dataList = newDataList;
    },

    handleShopCategoryMainEnter(index) {
      this.showMoreLabels = false;
      this.commodityList.forEach((item, i) => {
        item.showMore = i === index;
      });
    },
    handleShopCategoryWrapLeave() {
      this.commodityList.forEach((item) => {
        item.showMore = false;
      });
    },
    handleMouseEnter(event, child2) {
      child2.showMore = true;
      // 获取 category-level2-item 元素的位置
      const rect = event.currentTarget.getBoundingClientRect();
      // 设置 category-level3 盒子的 left 偏移量
      child2.leftOffset = rect.width;
    },

    async loadSwiperContent() {
      // 模拟异步加载内容
      return new Promise((resolve) => {
        setTimeout(() => {
          // 这里可以添加实际的异步加载逻辑
          resolve();
        }, 500);
      });
    },

    handleCurrentChange(e) {
      const loading = this.$loading({
        lock: true,
        text: "搜索中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      // 返回顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });

      this.params.Page = e;
      this.getCommondity(loading);
    },

    handleSearchAndHideLabels(params) {
      this.showMoreLabels = false;
      this.handleSearch(params);
    },
    handleSearchAndHideFixdCategory(params) {
      this.shopCategoryExpanded = false;
      this.shouldAddShopCategoryClass = false;
      // this.isTopReached = false;
      // 补充是否显示其他更多内容字段
      this.commodityList.forEach((item) => {
        item.showMore = false;
        if (item.childs2 && Array.isArray(item.childs2)) {
          item.childs2.forEach((child2) => {
            child2.showMore = false;
          });
        }
      });

      // 返回到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.handleSearch(params);
    },
    handleSearchAndHideHotSearch(params) {
      this.showAllHotSearch = false;
      this.handleSearch(params);
    },
    // 搜索数据
    handleSearch(value) {
      const loading = this.$loading({
        lock: true,
        text: "搜索中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      const { keyword, labels, labelid, labelid2, labelid3 } = value;
      this.params.keyword = keyword ?? "";
      this.params.labels = labels ?? "";
      this.params.labelid = labelid ?? "";
      this.params.labelid2 = labelid2 ?? "";
      this.params.labelid3 = labelid3 ?? "";
      this.getCommondity(loading);
    },

    // 重置数据
    handleRest() {
      const loading = this.$loading({
        lock: true,
        text: "重置中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      this.params.Page = 1;
      this.params.brandid = "";
      this.params.qyid = "";
      this.params.ordertype = "";
      this.params.keyword = "";
      this.params.labelid = "";
      this.params.labelid2 = "";
      this.params.labelid3 = "";
      this.params.labels = "";
      this.getCommondity(loading);
    },
    // 价格排序
    handleOrderType(type) {
      const loading = this.$loading({
        lock: true,
        text: "排序中，请稍后",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.9)",
      });
      this.params.ordertype = type;
      this.getCommondity(loading);
    },

    // 页面跳转
    handleGo(name) {
      this.$router.push({
        name,
      });
    },

    handleToast() {
      this.$message.warning("即将开放");
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, "_blank");
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
  <style lang="less" scoped>
.home_container {
  padding-top: 60px;
  box-sizing: border-box;
  background: #e7e8f0;
  .top_placeholder {
    height: 225px;
  }
  .head_container {
    // height: 260px;
    background: #fff;
    margin-bottom: 30px;
    padding: 20px 0 0;
    box-sizing: border-box;
    opacity: 1; /* 默认不透明 */
    top: 0; /* 默认位置 */
    transition: opacity 0.3s ease, top 0.3s ease; /* 只对 opacity 和 top 过渡 */
    &.top-reached {
      background: #fff;
      position: fixed;
      left: 0;
      top: 60px;
      right: 0;
      z-index: 999;
      margin-bottom: 0;
      .search_container {
        padding-bottom: 14px;
      }
    }
    .order_tip {
      width: 1360px;
      height: 50px;
      border-radius: 15px;
      box-shadow: -10px 0px 6px 0px rgba(214, 214, 214, 0.5),
        10px 0px 6px 0px rgba(214, 214, 214, 0.5);
      border: 3px solid #eeeff3;
      padding: 0 24px;
      box-sizing: border-box;
      margin: 0 auto 17px;
      .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      p {
        font-size: 16px;
        color: #333333;
        span {
          color: #ff0000;
          cursor: pointer;
        }
      }
      .close {
        font-size: 12px;
        color: #333333;
        cursor: pointer;
        .iconfont {
          font-size: 12px;
          margin-left: 4px;
        }
      }
    }
    .search_container {
      width: 1360px;
      margin: auto;
      .sraech_sort {
        font-size: 16px;
        color: #333333;
        padding-left: 24px;
        box-sizing: border-box;
        .rest_box {
          cursor: pointer;
          span {
            width: 25px;
            height: 21px;
            background: url("../assets/images/refresh_icon.png") no-repeat
              center;
            background-size: cover;
            margin-left: 9px;
          }
        }
        .ordertype_box {
          margin-left: 34px;
          cursor: pointer;
          .shangzhang_icon {
            width: 25px;
            height: 20px;
            background: url("../assets/images/shangzhang_icon.png") no-repeat
              center;
            background-size: cover;
            margin: 0 9px 0 10px;
          }
          .xiajiang_icon {
            width: 25px;
            height: 20px;
            background: url("../assets/images/xiazhang_icon.png") no-repeat
              center;
            background-size: cover;
          }
        }
      }
      .search {
        position: relative;
        .txt {
          font-size: 16px;
          color: #333333;
          font-weight: bold;
          padding: 0 8px 0 23px;
          box-sizing: border-box;
          cursor: pointer;
        }
        .search_input_box {
          width: 500px;
          height: 50px;
          background: #f0f0f0;
          border-radius: 25px;
          position: relative;
          /deep/ .el-input {
            padding: 0;
            height: 100%;
          }
          /deep/ .el-input__inner {
            height: 100%;
            background: none;
            border: none;
          }
          span {
            position: absolute;
            cursor: pointer;
            right: 20px;
            background: url("../assets/images/search_btn.png") no-repeat center;
            background-size: cover;
            width: 20px;
            height: 20px;
          }
        }
        .hot_search_list_expanded {
          position: absolute;
          left: 20px;
          top: 60px;
          width: 560px;
          min-height: 120px;
          background: #fff;
          box-shadow: 0px 6px 10px 0px rgba(13, 0, 0, 0.1);
          z-index: 10001;
          padding: 26px 10px 20px 35px;
          box-sizing: border-box;
          /* 确保内容在动画过程中不会溢出 */
          overflow: hidden;
          /* 新增过渡属性 */
          transition: all 0.3s ease;
          transform-origin: top;
          &::before {
            content: "";
            position: absolute;
            width: 65px;
            height: 10px;
            background: #000000;
            left: 0;
            top: 0;
          }
          .expanded_content {
            font-size: 16px;
            color: #026dd1;
            margin-bottom: 20px;
            p {
              line-height: 30px;
              margin-right: 28px;
              margin-bottom: 5px;
              cursor: pointer;
            }
          }
          .expanded_more {
            font-size: 16px;
            color: #333333;
            padding-right: 20px;
            box-sizing: border-box;
            span {
              background: url(../assets/images/barnd_icon.png) no-repeat center;
              background-size: cover;
              width: 23px;
              height: 20px;
              margin-right: 7px;
            }
            p {
              cursor: pointer;
            }
          }
        }
        /* 过渡动画 */
        .slide-enter-active,
        .slide-leave-active {
          transition: all 0.3s ease;
        }

        .slide-enter,
        .slide-leave-to {
          transform: scaleY(0);
          opacity: 0;
        }
      }
    }
    .shop_category_wrap {
      width: 1360px;
      margin: auto;
      padding: 0 19px;
      box-sizing: border-box;
      height: 123px;
      position: relative;
      .shop_category_main {
        height: 123px;
        cursor: pointer;
      }
    }
    .label_container {
      height: 80px;
      border-top: 1px solid #e7e8f0;
      padding: 0 310px;
      .icon {
        width: 16px;
        height: 17px;
        margin-right: 10px;
        background: url("../assets/images/label_icon.png") no-repeat center;
        background-size: cover;
        flex-shrink: 0;
      }
      .label_wrap {
        flex: 1;
        .label_list {
          position: relative;
          height: 80px;
          .label_item {
            font-size: 16px;
            color: #026dd1;
            margin-right: 25px;
            cursor: pointer;
            &:last-child {
              margin-right: 0;
            }
          }
          .more {
            width: 80px;
            height: 30px;
            background: #000000;
            border-radius: 15px;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
            margin-left: 40px;
          }
          .more-label-list {
            width: 650px;
            min-height: 200px;
            background: #ffffff;
            box-shadow: 0px 6px 10px 0px rgba(13, 0, 0, 0.1);
            position: absolute;
            top: 80px;
            right: 0;
            z-index: 9999;
            flex-wrap: wrap;
            padding: 30px 20px 20px 30px;
            box-sizing: border-box;
            align-items: flex-start;
            /* 确保内容在动画过程中不会溢出 */
            overflow: hidden;
            /* 新增过渡属性 */
            transition: all 0.3s ease;
            transform-origin: top;
            &::before {
              content: "";
              position: absolute;
              width: 80px;
              height: 10px;
              background: #000000;
              right: 0;
              top: -10px;
            }
            .label_item {
              cursor: pointer;
              margin-right: 25px;
              margin-bottom: 10px;
            }
          }
          /* 过渡动画 */
          .slide-enter-active,
          .slide-leave-active {
            transition: all 0.3s ease;
          }

          .slide-enter,
          .slide-leave-to {
            transform: scaleY(0);
            opacity: 0;
          }
        }
      }
    }
  }
  .commodity_container {
    padding-bottom: 180px;
    .more {
      span {
        cursor: pointer;
        background-size: cover;
        width: 110px;
        height: 30px;
        background: #000000;
        border-radius: 45px;
        font-size: 12px;
        color: #fff;
        padding: 0 14px;
        box-sizing: border-box;
        .iconfont {
          font-size: 10px;
          transform: rotate(-90deg);
        }
      }
    }
    .commodity_wrap {
      height: 610px;
      padding: 30px;
      box-sizing: border-box;
      .commodity_list {
        .commodity_list_item {
          margin-left: 36px;
          &:first-child {
            margin-left: 0;
          }
          .thumb {
            height: 290px;
          }
        }
      }
      // 倒数第二个commodity_wrap
      &:nth-last-child(2) {
        margin-bottom: 40px;
      }
    }
    
    .no_commodity {
      // padding-bottom: 180px;
      .no_commodity_content {
        width: 1360px;
        height: 610px;
        background: #ffffff;
        box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5);
        border-radius: 30px;
        margin: auto;
      }
    }
  }

  // 商品分类样式
  .shop_category_wrap {
    .shop_category_main {
      .thumb {
        width: 65px;
        height: 65px;
        margin-right: 10px;
        flex-shrink: 0;
      }
      .content {
        color: #333333;
        h1 {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 3px;
        }
        p {
          font-size: 14px;
        }
      }
    }
    /deep/ .swiper-button-prev {
      left: -35px;
      background-image: none;
      .iconfont {
        transform: rotate(180deg);
        font-size: 34px;
        display: inline-block;
      }
    }
    /deep/ .swiper-button-next {
      right: -35px;
      background-image: none;
      .iconfont {
        font-size: 34px;
        display: inline-block;
      }
    }

    .shop_category_other {
      width: 390px;
      background: #ffffff;
      box-shadow: 0px 6px 10px 0px rgba(13, 0, 0, 0.1);
      position: absolute;
      padding: 20px 20px 33px;
      box-sizing: border-box;
      &::before {
        content: "";
        position: absolute;
        width: 65px;
        height: 10px;
        background: #000000;
        left: 0;
        top: -10px;
      }
      .category-level2-level3 {
        align-items: flex-start;
        margin-right: 9px;
        .icon_box {
          width: 17px;
          margin-right: 9px;
          height: 40px;
          flex-shrink: 0;
          span {
            background: url(../assets/images/list_icon.png) no-repeat center;
            background-size: cover;
            width: 17px;
            height: 20px;
          }
        }
        .category-level2 {
          font-size: 16px;
          color: #333333;
          .category-level2-item {
            height: 40px;
            position: relative;
            &:hover {
              background: #ebeff3;
              border-radius: 20px 0 0 20px;
            }
            .txt {
              box-sizing: border-box;
              cursor: pointer;
              padding: 0 19px;
              height: 100%;
            }
            .category-level3 {
              min-width: 230px;
              background: #ebeff3;
              padding: 20px 0;
              box-sizing: border-box;
              font-size: 16px;
              color: #333333;
              position: absolute;
              top: 0; /* 让 category-level3 盒子向下展示 */
              .category-level3-item {
                box-sizing: border-box;
                cursor: pointer;
                padding: 8px 29px;
                position: relative;
                margin-bottom: 5px;
                &:last-child {
                  margin-bottom: 0;
                }
                &:hover {
                  background: #dae0e6;
                }
              }
            }
          }
        }
      }
      .keyword-labels {
        font-size: 16px;
        color: #026dd1;
        align-items: flex-start;
        margin-top: 30px;
        .icon {
          background: url(../assets/images/shop_label_icon.png) no-repeat center;
          background-size: cover;
          width: 20px;
          height: 19px;
          margin-right: 27px;
          flex-shrink: 0;
        }
        .content {
          .content_wrap {
            flex-wrap: wrap;
            p {
              font-size: 16px;
              color: #026dd1;
              cursor: pointer;
              margin-right: 15px;
              margin-bottom: 14px;
            }
          }
          .more {
            width: 80px;
            height: 30px;
            background: #000000;
            border-radius: 15px;
            font-size: 12px;
            color: #fff;
            cursor: pointer;
          }
        }
      }
    }
    /* 定义过渡动画 */
    .slide-down-enter-active,
    .slide-down-leave-active {
      transition: all 0.3s ease;
    }

    .slide-down-enter,
    .slide-down-leave-to {
      opacity: 0;
      transform: translateY(-20px);
    }

    /deep/.swiper-container {
      overflow: visible;
    }
  }

  /* 左侧固定内容样式 */
  .left-fixed {
    position: fixed;
    left: -200px; /* 默认隐藏在左侧 */
    top: 273px;
    width: 190px;
    z-index: 999;
    transition: left 0.3s ease; /* 添加过渡效果 */
    /* 滑动时显示左侧固定内容 */
    &.slide-in {
      left: 0; /* 从左到右滑出 */
    }

    /* 商品分类框样式 */
    .shop-category-wrap {
      width: 160px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5),
        -36px 0px 0px 0px #dcdcdc;
      border-radius: 0px 30px 30px 0px;
      margin-bottom: 20px;
      position: relative;
      transition: width 0.3s ease; /* 添加宽度过渡效果 */
      &::after {
        position: absolute;
        content: "";
        width: 60px;
        height: 130px;
        background: #dcdcdc;
        border-radius: 0px 30px 30px 0px;
        top: 0;
        right: -40px;
        z-index: -1;
      }

      /* 新增的订单提示框样式 */
      &.new-shop-category-style {
        width: 1350px;
        height: 130px;
        background: #ffffff;
        border-radius: 0px 30px 30px 0px;
        &::after {
          position: absolute;
          content: "";
          width: 60px;
          height: 130px;
          background: #000000;
          border-radius: 0px 30px 30px 0px;
          top: 0;
          right: -40px;
          z-index: -1;
        }
      }

      /* 商品分类框内容样式 */
      .shop-category-content {
        height: 130px;

        .shop-category-content-show {
          height: 100%;
          padding: 0 59px;
          box-sizing: border-box;
          position: relative;
          .shop_category_wrap {
            width: 100%;
            height: 100%;
          }
          /* 确保展开状态下 swiper 容器有正确的宽度 */
          .swiper-container {
            width: 100%; /* 或者根据实际需求设置宽度 */
            height: 100%;
          }
          .shop_category_main {
            height: 130px;
            cursor: pointer;
          }
          /deep/ .swiper-button-prev {
            left: 24px;
          }
          /deep/ .swiper-button-next {
            right: 24px;
          }
        }
        .shop-category-content-hide {
          height: 100%;
          .icon {
            background: url("../assets/images/commodity_cate.png") no-repeat
              center;
            background-size: cover;
            width: 105px;
            height: 65px;
          }
        }
      }
    }

    /* 订单提示框样式 */
    .order-tip-wrap {
      width: 90px;
      height: 130px;
      background: #ffffff;
      box-shadow: 0px 0px 16px 0px rgba(214, 214, 214, 0.5),
        -36px 0px 0px 0px #dcdcdc;
      border-radius: 0px 30px 30px 0px;
      position: relative;
      transition: width 0.3s ease; /* 添加宽度过渡效果 */
      &::after {
        position: absolute;
        content: "";
        width: 60px;
        height: 130px;
        background: #dcdcdc;
        border-radius: 0px 30px 30px 0px;
        top: 0;
        right: -40px;
        z-index: -1;
      }

      /* 新增的订单提示框样式 */
      &.new-order-tip-style {
        width: 280px;
        height: 130px;
        background: #ffffff;
        border-radius: 0px 30px 30px 0px;
        &::after {
          position: absolute;
          content: "";
          width: 60px;
          height: 130px;
          background: #000000;
          border-radius: 0px 30px 30px 0px;
          top: 0;
          right: -40px;
          z-index: -1;
        }
      }

      /* 订单提示框内容样式 */
      .order-tip-content {
        height: 130px;
        .order-tip-content-show {
          height: 100%;
          padding-left: 65px;
          box-sizing: border-box;
          align-items: flex-start;
          overflow: hidden;
          .txt {
            width: 143px;
            height: 33px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            line-height: 17px;
            white-space: nowrap;
          }
          .more {
            width: 125px;
            height: 17px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ff0000;
            line-height: 29px;
            white-space: nowrap;
            margin-top: 15px;
            cursor: pointer;
          }
        }
        .order-tip-content-hide {
          height: 100%;
          position: relative;
          .icon {
            background: url("../assets/images/message_icon_fixed.png") no-repeat
              center;
            background-size: cover;
            width: 50px;
            height: 50px;
          }
          span {
            width: 10px;
            height: 10px;
            background: #ff0000;
            border-radius: 50%;
            position: absolute;
            top: 47px;
          }
        }

        // .order-tip-content-show,
        // .order-tip-content-hide {
        //   height: 130px;
        //   opacity: 0;
        //   // max-height: 0;
        //   overflow: hidden;
        //   transition: opacity 0.3s ease-in-out, max-height 0.3s ease-in-out;
        // }
        // .order-tip-content-show.is-expanded,
        // .order-tip-content-hide.is-expanded {
        //   opacity: 1;
        //   // max-height: 130px; /* 根据实际内容调整最大高度 */
        // }
      }
    }

    .toggle-btn {
      position: absolute;
      width: 40px;
      height: 130px;
      cursor: pointer;
      right: -40px;
      top: 0;
      span {
        display: inline-block;
        width: 7px;
        height: 13px;
        background: url("../assets/images/toggle_zhan.png") no-repeat center;
      }
      &.new-toggle-btn {
        span {
          background: url("../assets/images/toggle_shou.png") no-repeat center;
        }
      }
    }
  }

  /deep/.el-dialog {
    width: 900px;
    height: 450px;
    background: #e7e9f1;
    border-radius: 30px;
    margin-top: 170px !important;
  }
  /deep/.el-dialog__header {
    height: 105px;
    padding: 0 55px;
    box-sizing: border-box;
    .custom-header {
      height: 100%;
      position: relative;
      .tit {
        font-size: 20px;
        color: #333333;
      }
      .close {
        position: absolute;
        right: -35px;
        top: 15px;
        cursor: pointer;
        background: url("../assets/images/close_icon.png") no-repeat center;
        background-size: cover;
        width: 30px;
        height: 30px;
      }
    }
  }
  /deep/.el-dialog__body {
    padding: 0;
    .content {
      padding: 0 55px;
      box-sizing: border-box;
      .item {
        width: 360px;
        height: 270px;
        background: #ffffff;
        border-radius: 30px;
        border: 1px dashed #626262;
        &:last-child {
          .img {
            width: 122px;
            height: 120px;
          }
        }
        .img {
          width: 127px;
          height: 120px;
        }
        .btn {
          width: 190px;
          height: 50px;
          background: #e7e9f1;
          border-radius: 25px;
          font-size: 16px;
          color: #333333;
          margin-top: 13px;
          cursor: pointer;
          &::before {
            display: inline-block;
            content: "";
            background: url("../assets/images/edit_icon.png") no-repeat center;
            background-size: cover;
            width: 18px;
            height: 20px;
            margin-right: 10px;
          }
        }
      }
    }
  }
}
</style>